import React, { useState, useEffect, useRef } from "react";
import { Button, Container } from "reactstrap";

const slides = [
    {
        image: "https://images.unsplash.com/photo-1613665813446-82a78c468a1d?q=80&w=2058&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        title: "Enerjiniz Özgür Olsun.",
        subtitle: "Büyük ölçekli solar projelerde uzman mühendislik ve maksimum verim.",
    },
    {
        image: "https://images.unsplash.com/photo-1626251376234-8bc112f0bcd5?q=80&w=2088&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        title: "Sürdürülebilir Enerjiye Geçin.",
        subtitle: "Yenilenebilir enerji ile geleceğe yatırım yapın.",
    },
    {
        image: "https://images.unsplash.com/photo-1707247111552-aaf74241058b?q=80&w=2124&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        title: "Geleceğe Yatırım Yapın.",
        subtitle: "Enerji çözümlerimizle yarının dünyasını bugünden şekillendirin.",
    },
];

function LandingPageHeader(props) {
    const [currentSlide, setCurrentSlide] = useState(0);
    const slideTimeout = useRef(null);

    // Otomatik geçiş (5 sn)
    useEffect(() => {
        slideTimeout.current = setTimeout(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 5000);

        return () => clearTimeout(slideTimeout.current);
    }, [currentSlide]);

    const goToPrev = () => {
        clearTimeout(slideTimeout.current);
        setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    };

    const goToNext = () => {
        clearTimeout(slideTimeout.current);
        setCurrentSlide((prev) => (prev + 1) % slides.length);
    };

    const slide = slides[currentSlide];

    return (
        <div
            className="page-header"
            style={{
                backgroundImage: `url(${slide.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                height: "100vh",
                position: "relative",
                transition: "background-image 0.8s ease-in-out",
            }}
            data-parallax={true}
        >
            <div className="filter" />
            <Container>
                <div className="motto text-center">
                    <h1>{slide.title}</h1>
                    <h3>{slide.subtitle}</h3>
                    <br />
                    <Button
                        onClick={() => props.handleScrollProducts()}
                        className="btn-round m-2"
                        color="neutral"
                        outline
                    >
                        Ürünler
                    </Button>
                    <Button
                        onClick={() => props.handleScrollContact()}
                        className="btn-round"
                        color="neutral"
                        type="button"
                        outline
                    >
                        İletişim
                    </Button>
                </div>
                {/* Slider kontrol butonları */}
                <div
                    style={{
                        position: "absolute",
                        bottom: 20,
                        right: 20,
                        display: "flex",
                        gap: 10,
                        zIndex: 10,
                    }}
                >
                    <Button onClick={goToPrev} className="btn-round" color="neutral" outline>
                        ‹
                    </Button>
                    <Button onClick={goToNext} className="btn-round" color="neutral" outline>
                        ›
                    </Button>
                </div>
            </Container>
        </div>
    );
}

export default LandingPageHeader;
